"use strict";

var _regeneratorRuntime = require("/var/www/attheme-editor.snejugal.ru/node_modules/@babel/runtime/regenerator");

var _toConsumableArray = require("/var/www/attheme-editor.snejugal.ru/node_modules/@babel/runtime/helpers/toConsumableArray");

var _slicedToArray = require("/var/www/attheme-editor.snejugal.ru/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/var/www/attheme-editor.snejugal.ru/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/var/www/attheme-editor.snejugal.ru/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var parseContents_1 = require("./parseContents");

var serializeTheme_1 = require("./serializeTheme");

var Attheme =
/*#__PURE__*/
function () {
  /**
   * Constructs a new theme.
   * @param contents The .attheme contents to parse.
   */
  function Attheme(contents) {
    _classCallCheck(this, Attheme);

    this._variables = new Map();
    this._wallpaper = null;

    if (typeof contents === "string") {
      var _parseContents_1$defa = parseContents_1["default"](contents),
          variables = _parseContents_1$defa.variables,
          wallpaper = _parseContents_1$defa.wallpaper;

      this._variables = variables;
      this._wallpaper = wallpaper;
    } else if (contents) {
      var iterator = contents[Symbol.iterator]();

      while (true) {
        var result = iterator.next();

        if (result.done) {
          break;
        } else {
          var _result$value = _slicedToArray(result.value, 2),
              variable = _result$value[0],
              color = _result$value[1];

          this._variables.set(variable, Object.assign({}, color));
        }
      }
    }
  }
  /**
   * Gets the theme's wallpaper.
   * @returns The theme's wallpaper.
   */


  _createClass(Attheme, [{
    key: "getWallpaper",
    value: function getWallpaper() {
      return this._wallpaper ? this._wallpaper : null;
    }
    /**
     * Sets the new wallpaper.
     * @param newWallpaper The new wallpaper.
     */

  }, {
    key: "setWallpaper",
    value: function setWallpaper(newWallpaper) {
      this._wallpaper = newWallpaper;
    }
    /**
     * Checks whether the theme has a wallpaper.
     * @returns Whether the theme has a wallpaper.
     */

  }, {
    key: "hasWallpaper",
    value: function hasWallpaper() {
      return typeof this._wallpaper === "string";
    }
    /**
     * Deletes the wallpaper.
     */

  }, {
    key: "deleteWallpaper",
    value: function deleteWallpaper() {
      delete this._wallpaper;
    }
    /**
     * Checks whether the theme has the specified variables.
     * @param variable The varialbe to check existence of.
     * @returns Whehter the theme has the variable.
     */

  }, {
    key: "has",
    value: function has(variable) {
      return this._variables.has(variable);
    }
    /**
     * Deletes the variable.
     * @param variable The variable to delete.
     */

  }, {
    key: "delete",
    value: function _delete(variable) {
      this._variables["delete"](variable);
    }
    /**
     * Gets the value of the specified variable.
     * @param variable The variable to get value of.
     * @returns The value of the variable.
     */

  }, {
    key: "get",
    value: function get(variable) {
      var value = this._variables.get(variable);

      return value === undefined ? null : Object.assign({}, value);
    }
    /**
     * Sets the variable to the specified value.
     * @param variable The variable to set.
     * @param value The value of the variable.
     */

  }, {
    key: "set",
    value: function set(variable, value) {
      this._variables.set(variable, Object.assign({}, value));
    }
    /**
     * Gets the amount of variables in the theme.
     * @returns The amount of variable in the theme.
     */

  }, {
    key: "getVariablesAmount",
    value: function getVariablesAmount() {
      return this._variables.size;
    }
    /**
     * Gets an array of all variables in the theme.
     * @returns An array of varialbes.
     */

  }, {
    key: "getVariablesList",
    value: function getVariablesList() {
      return _toConsumableArray(this._variables.keys());
    }
    /**
     * Sorts the theme's variables by their names in place.
     */

  }, {
    key: "sort",
    value: function sort() {
      this._variables = new Map(_toConsumableArray(this._variables).sort(function (_ref, _ref2) {
        var _ref3 = _slicedToArray(_ref, 1),
            a = _ref3[0];

        var _ref4 = _slicedToArray(_ref2, 1),
            b = _ref4[0];

        return a.localeCompare(b);
      }));
    }
    /**
     * Fallbacks this theme to another theme:
     *
     * - Every variable which is present in `other` but not in `this`, is copied
     *   to `this`.
     * - If `this` doesn't have a wallpaper, the wallpaper is copied from `other`.
     *
     * @param other The other theme to fallback to.
     */

  }, {
    key: "fallbackToOther",
    value: function fallbackToOther(other) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = other._variables[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref7 = _step.value;

          var _ref6 = _slicedToArray(_ref7, 2);

          var variable = _ref6[0];
          var color = _ref6[1];

          if (!this._variables.has(variable)) {
            this._variables.set(variable, Object.assign({}, color));
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator["return"] != null) {
            _iterator["return"]();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (typeof this._wallpaper !== "string") {
        this._wallpaper = other._wallpaper;
      }
    }
    /**
     * Fallbacks variables to other existing variabled according to the map.
     * @param fallbackMap Defines variable mapping.
     */

  }, {
    key: "fallbackToSelf",
    value: function fallbackToSelf(fallbackMap) {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = fallbackMap[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var _ref10 = _step2.value;

          var _ref9 = _slicedToArray(_ref10, 2);

          var variable = _ref9[0];
          var fallback = _ref9[1];

          if (!this._variables.has(variable) && this._variables.has(fallback)) {
            this._variables.set(variable, Object.assign({}, this._variables.get(fallback)));
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
            _iterator2["return"]();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }
  }, {
    key: Symbol.iterator,
    value:
    /*#__PURE__*/
    _regeneratorRuntime.mark(function value() {
      var _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, _ref13, _ref12, variable, value, entry;

      return _regeneratorRuntime.wrap(function value$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _iteratorNormalCompletion3 = true;
              _didIteratorError3 = false;
              _iteratorError3 = undefined;
              _context.prev = 3;
              _iterator3 = this._variables[Symbol.iterator]();

            case 5:
              if (_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done) {
                _context.next = 16;
                break;
              }

              _ref13 = _step3.value;
              _ref12 = _slicedToArray(_ref13, 2);
              variable = _ref12[0];
              value = _ref12[1];
              entry = [variable, Object.assign({}, value)];
              _context.next = 13;
              return entry;

            case 13:
              _iteratorNormalCompletion3 = true;
              _context.next = 5;
              break;

            case 16:
              _context.next = 22;
              break;

            case 18:
              _context.prev = 18;
              _context.t0 = _context["catch"](3);
              _didIteratorError3 = true;
              _iteratorError3 = _context.t0;

            case 22:
              _context.prev = 22;
              _context.prev = 23;

              if (!_iteratorNormalCompletion3 && _iterator3["return"] != null) {
                _iterator3["return"]();
              }

            case 25:
              _context.prev = 25;

              if (!_didIteratorError3) {
                _context.next = 28;
                break;
              }

              throw _iteratorError3;

            case 28:
              return _context.finish(25);

            case 29:
              return _context.finish(22);

            case 30:
            case "end":
              return _context.stop();
          }
        }
      }, value, this, [[3, 18, 22, 30], [23,, 25, 29]]);
    })
    /**
     * Serializes the theme.
     * @param colorSignature The way the colors should be serialized. "hex" for
     * #aarrggbb and "int" for Java int color.
     * @returns The serialized theme.
     */

  }, {
    key: "toString",
    value: function toString(colorSignature) {
      return serializeTheme_1["default"](this, colorSignature);
    }
  }]);

  return Attheme;
}();

exports["default"] = Attheme;